export default "__VITE_ASSET__a7717c22__"